import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { BrowserTabConstant } from '../../common/constants/browser-tab-constant';
import { HeaderDescriptionDataModel } from '../../common/models/audit-trail.model';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrl: './audit-trail.component.less',
})
export class AuditTrailComponent implements OnInit {
  submissionId: number | null = null;
  opportunityNumber!: string;
  readonly #destroy$: Subject<void> = new Subject<void>();
  titleValue: string | null = null;
  submissionTypeValue: string | null = null;
  clientNameValue: string | null = null;
  opportunityNameValue: string | null = null;
  isExtCommSubmission: boolean = false;
  isGlobalEngagement: boolean = false;
  isIntake: boolean = false;
  isOpportunitySummary: boolean = false;

  ngOnInit(): void {
    this.isExtCommSubmission = !!history.state.extComm;
    this.isGlobalEngagement = !!history.state.globalEngagements;
    this.isIntake = !!history.state.intake;
    this.isOpportunitySummary = !!history.state.opportunitySummary;
    document.title = BrowserTabConstant.Browser_TabName_AuditTrail;
    if (this.isIntake || this.isOpportunitySummary) {
      this.submissionId = history.state.submissionId;
      this.opportunityNumber = history.state.opportunityNumber;
    } else if (this.isExtCommSubmission) {
      this.submissionId = history.state.submissionId;
      this.opportunityNumber = history.state.opportunityNumber;
    } else if (this.isGlobalEngagement) {
      this.submissionId = history.state.submissionId;
      this.opportunityNumber = history.state.opportunityNumber;
    }
    
  }

  headerData(data: HeaderDescriptionDataModel): void {
    this.titleValue = data.submissionTitle;
    this.submissionTypeValue = data.submissionTypeCode;
    this.clientNameValue = data.clientName;
    this.opportunityNameValue = data.opportunityName;
  }

  ngOnDestroy(): void {
    this.#destroy$.next();
    this.#destroy$.complete();
  }
}
